import React from "react";
import { defaultStyle } from "./style";
import { css } from "emotion";
import { Button as AtomicButton } from "@maxmilhas/hangar-components-atomic/public";
import theme from "../../../js/shared/new-theme"

const Button = props => {
    const colorToUse = theme.palette[props.color]
        ? theme.palette[props.color][500].value
        : props.color || theme.palette.secondary[500].value;
    const buttonStyle = defaultStyle(colorToUse, props.outline, props.disabled);
    return (
        <div
            className={css`
				${buttonStyle}
			`}
        >
            <AtomicButton {...props} color={colorToUse} />
        </div>
    );
};
export default Button;